<template>
  <div class="content-card-tags" v-if="tags && tags.length">
    <div class="content-card-tag" v-for="(tag, i) in tags" :key="i">
      #{{ tag }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentCardTags",
  props: {
    tags: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
.content-card-tags {
  .content-card-tag {
    text-transform: capitalize;
    font-size: 1.2rem;
    padding: 3px 8px;
    margin-bottom: 2px;
    border: 1px solid #555;
    border-radius: 100px;
    max-width: 90px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
